import { ProductContentItem } from '../../generated/graphql'

export type PricePerUnit = {
  displayValue?: string
  unit?: string
}

export const pricePerUnit = (
  currency?: string,
  content?: ProductContentItem[] | null,
  amount?: string,
) => {
  if (!amount || !content || !currency) {
    return null
  }

  const contentKeyQuantity = content?.find(
    (contentItem) => contentItem.key === 'ppu_quantity',
  )?.value

  const contentKeyUnit = content?.find(
    (contentItem) => contentItem.key === 'ppu_unit',
  )?.value

  const quantity: string =
    contentKeyQuantity && 'stringValue' in contentKeyQuantity
      ? contentKeyQuantity.stringValue
      : null

  const unit: string =
    contentKeyUnit &&
    'stringListValue' in contentKeyUnit &&
    contentKeyUnit.stringListValue?.[0]?.length > 0 &&
    contentKeyUnit.stringListValue?.[0]

  if (!quantity || !unit) {
    return {
      displayValue: '',
      unit: '',
      __typename: 'PricePerUnit',
    }
  }
  const currencySymbol = currency.replace(/[0-9\.,]+/g, '')
  const value = parseFloat(amount) / parseFloat(quantity || '0')

  const displayValue = currencySymbol.concat(value.toFixed(2).toString())

  return { displayValue, unit, __typename: 'PricePerUnit' }
}
